import { useQuery } from '@tanstack/react-query';
import { dataSourceRoot, getDataSource } from '../data/dataSourceFactory';
import type { DicomJson } from '../data/dicomTags';

/**
 * WADO-RS series metadata: the array of per-instance datasets (for WSI, one per
 * pyramid level). This is consumed both by the rendering engine (DMV) and the
 * metadata panel — TanStack Query dedupes so it's fetched once.
 */
export function useSeriesMetadata(
  studyInstanceUID: string | undefined,
  seriesInstanceUID: string | undefined,
  /** False holds the request back, but still answers from the cache. */
  enabled = true,
) {
  return useQuery<DicomJson[]>({
    queryKey: ['series-metadata', dataSourceRoot(), studyInstanceUID, seriesInstanceUID],
    enabled: enabled && !!studyInstanceUID && !!seriesInstanceUID,
    queryFn: () => getDataSource().retrieveSeriesMetadata(studyInstanceUID!, seriesInstanceUID!),
  });
}
